import { Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import InputField from '../../forms/input-field'
import { useDispatch } from 'react-redux';
import AddButton, { DraftButton } from '../../buttons/button';
import * as Yup from "yup";
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import InnerLayout from '../../layouts/inner-layout';
import successToast from '../../helper-components/success-toast';
import errorToast from '../../helper-components/error-toast';
import { phonepeAddAction, phonepeUpdateAction, phonepeViewAction } from '../../../redux/actions/settings-action';

const PhonePeConfiguration = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const [phonepeData, setPhonepeData] = useState({})

    useEffect(() => {
        dispatch(phonepeViewAction({}, onSuccess, onError));
    }, []);

    const reload = () => {
        dispatch(phonepeViewAction({}, onSuccess, onError))
    }

    const onSuccess = (data) => {
        
        setPhonepeData(data?.data);
    };
    const onError = (data) => {  errorToast(data?.message) };

    const initialValues = {
        id: phonepeData?.id || null,
        host_url: phonepeData?.host_url || "",
        merchant_id: phonepeData?.merchant_id || "",
        secret_key: phonepeData?.secret_key || "",
    }

    const validationSchema = Yup.object().shape({
        host_url: Yup.string().required("Required"),
        merchant_id: Yup.string().required("Required"),
        secret_key: Yup.string().required("Required"),
    });

    const onSubmit = (values) => {
        
        if (values.id) {
            dispatch(phonepeUpdateAction(values, onCreateSuccess, onError))
        } else {
            dispatch(phonepeAddAction(values, onCreateSuccess, onError))
        }
    }

    const onCreateSuccess = (data) => { successToast(data?.message); reload() };

    return (
        <InnerLayout
            list={true}
            title="Settings"
            module="Phonpe-configuration"
        // permissionFn={permissionFn}
        >
            <div className='pl-4'>
                <div className='flex justify-between pt-3'>
                    <div className=" pb-4 flex items-center gap-2">
                        <button
                            className="flex items-center gap-2"
                            onClick={() => {
                                navigate('/settings')
                            }}
                        >
                            <ChevronLeftIcon className="h-5 w-5 inline-block" />
                            Settings /
                        </button>
                        <span className="cursor-pointer" >{" " + "Phonepe Configuration"}</span>
                    </div>
                </div>
                <Formik
                    enableReinitialize={true}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ values, setFieldValue, handleSubmit }) => (
                        <Form className="pl-4 pt-4">
                            <div
                                style={{ height: "78vh" }}
                            >

                                <div className="w-full flex flex-col gap-4">
                                    <div style={{ maxWidth: "30rem" }} className="w-full">
                                        <InputField
                                            containerClass="mt-1"
                                            isRequired={true}
                                            type="text"
                                            name="host_url"
                                            placeholder="Enter Host Url"
                                            label="Host Url"
                                            labelWidth="7rem"
                                        />
                                    </div>
                                    <div style={{ maxWidth: "30rem" }} className="w-full">
                                        <InputField
                                            containerClass="mt-1"
                                            isRequired={true}
                                            type="text"
                                            name="merchant_id"
                                            placeholder="Phonepe Merchant Id"
                                            label="Merchant Id"
                                            labelWidth="7rem"
                                        />
                                    </div>
                                    <div style={{ maxWidth: "30rem" }} className="w-full">
                                        <InputField
                                            containerClass="mt-1"
                                            isRequired={true}
                                            type="text"
                                            name="secret_key"
                                            placeholder="Phonepe Secret Key"
                                            label="Secret Key"
                                            labelWidth="7rem"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="flex justify-between px-6  bg-white py-4 invoice-bottom-container">
                                <DraftButton
                                    onclkFn={() => navigate(`/settings`)}
                                    text="Cancel"
                                />
                                <AddButton
                                    onclkFn={handleSubmit}
                                    prefixIcon={false}
                                    text="Save"
                                    type="submit"
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </InnerLayout>
    )
}

export default PhonePeConfiguration
